module.exports = __webpack_public_path__ + "img/品質管理3-4.1c7e9770.png";